/**
 * 予定時刻設定モーダル（登降園予定・中抜け予定共通）
 *
 * editItem の期待形式:
 *   - date: Date                  対象日
 *   - memberName: string          園児名
 *   - titleSuffix: string         タイトルサフィックス（例: '登降園予定'、'中抜け予定'）
 *   - startTime: Date | null      開始時刻の初期値
 *   - endTime: Date | null        終了時刻の初期値
 *   - startLabel: string          バリデーションエラー用ラベル（例: '登園予定'、'外出予定'）
 *   - endLabel: string            バリデーションエラー用ラベル（例: '降園予定'、'戻り予定'）
 *
 * close で返す値:
 *   { startTime: Date | null, endTime: Date | null }
 */
function scheduleTimeModalCtrl($scope, $modalInstance, $filter, editItem) {
  const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][editItem.date.getDay()];

  $scope.scheduleTimeTitle = editItem.memberName + 'さんの' + editItem.titleSuffix;
  $scope.scheduleTimeDate = $filter('date')(editItem.date, 'yyyy年M月d日') + '(' + dayOfWeek + ')';
  $scope.scheduleTime = {
    startTime: editItem.startTime ? new Date(editItem.startTime) : new Date(),
    endTime: editItem.endTime ? new Date(editItem.endTime) : new Date(),
  };
  $scope.scheduleTimeError = null;
  $scope.startTimeHasError = false;
  $scope.endTimeHasError = false;

  $scope.saveScheduleTime = function () {
    $scope.startTimeHasError = false;
    $scope.endTimeHasError = false;

    if (!$scope.scheduleTime.startTime && !$scope.scheduleTime.endTime) {
      $modalInstance.close({ startTime: null, endTime: null });
      return;
    }
    if (!$scope.scheduleTime.startTime) {
      $scope.scheduleTimeError = editItem.startLabel + 'を入力してください';
      $scope.startTimeHasError = true;
      return;
    }
    if (!$scope.scheduleTime.endTime) {
      $scope.scheduleTimeError = editItem.endLabel + 'を入力してください';
      $scope.endTimeHasError = true;
      return;
    }
    if ($scope.scheduleTime.startTime >= $scope.scheduleTime.endTime) {
      $scope.scheduleTimeError = editItem.startLabel + 'は' + editItem.endLabel + 'より前の時刻を入力してください';
      $scope.startTimeHasError = true;
      $scope.endTimeHasError = true;
      return;
    }
    $scope.scheduleTimeError = null;

    const result = {
      startTime: new Date($scope.scheduleTime.startTime),
      endTime: new Date($scope.scheduleTime.endTime),
    };
    result.startTime.setSeconds(0);
    result.startTime.setMilliseconds(0);
    result.endTime.setSeconds(0);
    result.endTime.setMilliseconds(0);

    $modalInstance.close(result);
  };

  $scope.cancelScheduleTime = function () {
    $modalInstance.dismiss('cancel');
  };
}

angular.module('inspinia').controller('scheduleTimeModalCtrl', scheduleTimeModalCtrl);
